import { envSettings } from "core/EnvSettings";
import React from "react";
import { Resource } from "react-admin";
import { Route } from "react-router-dom";
import { hotlinksResource } from "resources/hotlinks";
import { oAuth2RequestsResource } from "resources/oauth2-requests";
import { ordersByAPIResource } from "resources/orders-by-api";
import { storageTransactionsResource } from "resources/storage-transactions";

import { commoditiesResource } from "../../resources/commodities";
import { customerArticlesResource } from "../../resources/customer-articles";
import { customerCompaniesResource } from "../../resources/customer-companies/";
import { customerUsers } from "../../resources/customer-users";
import { deviationsResource } from "../../resources/deviations";
import { deviationsRoutes } from "../../resources/deviations/deviations_routes";
// import { transportersResource } from '../../resources/transporters';
import { customerDriversResource } from "../../resources/drivers";
import { commonEntitiesResource } from "../../resources/entities/";
import { entityDocumentStatusResource } from "../../resources/entity-document-status";
import { financialStatementsResource } from "../../resources/financial-statements";
import { inventoryListResource } from "../../resources/inventory-list";
import { laborForecastResource } from "../../resources/labor-forecast";
// import { mappersResource } from "../../resources/mappers";
import Messages from "../../resources/messages/List/List";
import { notifLogsResource } from "../../resources/notif-logs";
import { orderGroupsResource } from "../../resources/order-groups";
import { ordersDraftResource, ordersResource } from "../../resources/orders/";
import { OrdersMultipleChangesPage } from "../../resources/orders/MultipleChanges2";
import { osfcManagersResource } from "../../resources/osfc-users";
import { outdoorDisplayTaskDisplayActionResource } from "../../resources/outdoor-display";
import { areasResource, portsResource } from "../../resources/ports-areas";
import { articleTemplatesResource } from "../../resources/pricelist-article-templates";
import { pricelistArticlesResource } from "../../resources/pricelist-articles/";
import { pricelistHolidaysResource } from "../../resources/pricelist-holidays/";
import { recurringTaskResource } from "../../resources/recurring_tasks";
import { tasksResource } from "../../resources/tasks/";
import { terminalsResource } from "../../resources/terminal";
import { terminalSettingPerDateResource } from "../../resources/terminal-setting-per-date";
import { transportTrailersResource } from "../../resources/trailers";
import { translationsResource } from "../../resources/translations";
import { transportTrucksResource } from "../../resources/trucks";
import { trucksTrafficResource } from "../../resources/trucks-traffic";
import { vehicleANPRCamerasResource } from "../../resources/vehicle-anpr-cameras";
import { authenticatedResources } from "./authenticated";

export const appManagerResources = [
	<Resource name="orders" {...ordersResource} />,
	<Resource {...deviationsResource} name="deviations" />,
	<Resource name="order-groups" {...orderGroupsResource} />,
	envSettings.REACT_APP_FF_STORAGE_MODULE && (
		<Resource {...storageTransactionsResource} name="storage-transactions" />
	),
	<Resource name="draft-orders" {...ordersDraftResource} />,
	<Resource {...osfcManagersResource} name="company-users" />,
	// <Resource {...mappersResource} name="mappers" />,
	<Resource {...customerCompaniesResource} name="customer-companies" />,
	<Resource {...customerUsers} name="customer-users" />,
	<Resource name="orders-by-api" {...ordersByAPIResource} />,
	<Resource name="oauth2-requests" {...oAuth2RequestsResource} />,

	// <Resource {...transportersResource} name="transporters" />,
	<Resource name="transporters" intent="registration" />,
	<Resource {...customerDriversResource} create={null} edit={null} name="drivers" />,
	<Resource {...transportTrucksResource} name="trucks" create={null} edit={null} delete={null} />,
	<Resource
		{...transportTrailersResource}
		name="trailers"
		create={null}
		edit={null}
		delete={null}
	/>,
	<Resource
		{...pricelistArticlesResource}
		name="pricelist-articles"
		options={{ hasUpload: false }}
	/>,
	<Resource {...pricelistHolidaysResource} name="pricelist-holidays" />,
	<Resource {...commoditiesResource} name="commodities" />,
	<Resource {...customerArticlesResource} name="customer-articles" />,
	<Resource {...portsResource} name="ports" intent="registration" />,
	<Resource {...areasResource} name="areas" intent="registration" />,
	<Resource
		{...articleTemplatesResource}
		name="pricelist-article-templates"
		intent="registration"
	/>,
	<Resource name="pallets-and-boxes" intent="registration" />,

	<Resource name="notif-logs" {...notifLogsResource} />,
	<Resource name="trucks-traffic" {...trucksTrafficResource} />,
	<Resource name="vehicle-anpr-cameras" {...vehicleANPRCamerasResource} />,
	<Resource name="labor-forecast" {...laborForecastResource} />,
	<Resource name="recurring-tasks" {...recurringTaskResource} />,
	<Resource {...hotlinksResource} name="hotlinks" />,
	<Resource name="financial-statements" {...financialStatementsResource} />,
	<Resource name="task-display-actions" {...outdoorDisplayTaskDisplayActionResource} />,

	<Resource {...translationsResource} name="translations" />,

	<Resource name="backup-pricelist-articles-with-special" intent="registration" />,
	<Resource name="pricelist-special-price" intent="registration" />,
	<Resource name="customer-employees" intent="registration" />,

	<Resource name="users" intent="registration" />,
	<Resource name="companies" intent="registration" />,
	<Resource name="storage-places" intent="registration" />,
	<Resource name="storage-places-lookup" intent="registration" />,
	<Resource name="order-statuses" intent="registration" />,
	<Resource name="outgoing-doc-statuses" intent="registration" />,
	<Resource name="company-notifications" intent="registration" />,
	<Resource {...terminalsResource} name="terminal" />,
	<Resource name="external-terminal-links" intent="registration" />,
	<Resource name="customer-company-mappers" intent="registration" />,
	<Resource name="cooler-types" intent="registration" />,
	<Resource name="order-pricelist-history" intent="registration" />,
	<Resource
		name="order-pricelist"
		intent="registration"
		options={{ hasAdd: true, hasEdit: true }}
	/>,

	<Resource name="tasks" {...tasksResource} />,
	<Resource name="entities" {...commonEntitiesResource} />,
	<Resource name="order-history" intent="registration" />,
	<Resource name="pallet-history" intent="registration" />,
	<Resource name="task-history" intent="registration" />,
	<Resource name="entity-history" intent="registration" />,
	<Resource name="task-statuses" intent="registration" />,
	<Resource name="deviation-statuses" intent="registration" />,

	<Resource {...customerDriversResource} create={null} edit={null} name="drivers" />,
	<Resource name="order-statuses" intent="registration" />,
	<Resource name="companies" intent="registration" />,
	<Resource name="company-notifications" intent="registration" />,
	<Resource name="rank-priorities" intent="registration" />,
	<Resource name="entity-document-status" {...entityDocumentStatusResource} />,
	<Resource name="deviations-history" intent="registration" />,
	<Resource name="document-templates" intent="registration" />,
	<Resource name="mappers" intent="registration" />,
	<Resource name="custom-fields" intent="registration" />,
	<Resource name="product-articles" intent="registration" />,
	<Resource name="order-product-articles" intent="registration" />,
	<Resource name="product-numbers" intent="registration" />,
	<Resource name="product-names" intent="registration" />,
	<Resource name="automatic-pallets-reservation" intent="registration" />,
	<Resource name="pallets" intent="registration" />,
	<Resource name="storage-inventorization-statuses" intent="registration" />,
	<Resource name="inventory-list" {...inventoryListResource} />,
	<Resource name="terminal-setting-per-date" {...terminalSettingPerDateResource} />,
	...authenticatedResources,
];

export const appManagerRoutes = [
	...Object.values(deviationsRoutes),
	deviationsRoutes.edit,
	<Route exact path="/messages" component={Messages} />,
	<Route exact path="/orders/multiple-changes" component={OrdersMultipleChangesPage} />,
	<Route exact path="/draft-orders/multiple-changes" component={OrdersMultipleChangesPage} />,
];
